import type { Failure } from "@/modules/shared/failure";
import { renderFieldErrors } from "@/modules/shared/fieldCopy";
import { SYSTEM_ERROR, type FormState } from "@/modules/shared/forms";

/**
 * The **web's** copy for the Customer Records commands, and the one place a
 * `Failure` becomes a `FormState` (R22 T7). Every sentence is unchanged from
 * before the cores existed.
 */
export function notesCopyFor(failure: Failure): string {
  switch (failure.code) {
    case "customer_not_found":
      return "This customer could not be found.";
    case "note_not_found":
      return "That note is already gone.";
    case "note_edit_forbidden":
      return "You can only edit your own notes.";
    case "note_delete_forbidden":
      // Says who *can*, because unlike the edit refusal there is somebody to
      // ask: a Manager may remove what should not have been written (H42).
      return "Only the author or a manager can delete this note.";
    default:
      return SYSTEM_ERROR;
  }
}

export function formStateFor(
  failure: Failure,
  values?: Record<string, string>,
): FormState {
  if (failure.fieldErrors) {
    return { fieldErrors: renderFieldErrors(failure.fieldErrors), values };
  }
  return { formError: notesCopyFor(failure), values };
}
